enum AccessKeyEditType {
  Name = 'Name',
  Expiry = 'Expiry',
  Container = 'Container',
  DocumentType = 'DocumentType',
  Permission = 'Permission',
}
export default AccessKeyEditType;
